(function () {
  const $ = (selector) => document.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const navigateToResults = (value) => {
    const url = value instanceof URL ? value : new URL(value, location.href);
    if (
      $('[data-search-server-terms]') &&
      typeof window.DutchXXLTheme?.navigateToFullSearch === 'function'
    ) {
      window.DutchXXLTheme.navigateToFullSearch(url);
      return;
    }

    location.assign(url.toString());
  };

  const initFilterDrawer = () => {
    const drawer = $('[data-filter-drawer]');
    if (!drawer) return;

    const overlay = $('[data-filter-overlay]');
    const toggleBtn = $('[data-filter-toggle]');
    const closeBtn = $('[data-filter-close]');
    const openClass = 'filter-drawer--open';
    const overlayClass = 'filter-drawer-overlay--visible';
    const bodyOpenClass = 'filter-drawer-is-open';
    const mobileMedia = window.matchMedia('(max-width: 1199px)');
    const shouldOpenMobileFilterSections = drawer.hasAttribute('data-mobile-open-filter-sections');
    const filterSectionInitialState = shouldOpenMobileFilterSections
      ? $$('details.filter-section', drawer).map((section) => ({
        section,
        open: section.open,
      }))
      : [];
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    let previousBodyOverflow = '';
    let mobileFilterSectionsOpened = false;

    const getFocusableElements = () =>
      [...drawer.querySelectorAll(focusableSelector)].filter((element) => {
        if (element.closest('[hidden], [inert]')) return false;
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });

    const syncAccessibility = () => {
      const isMobile = mobileMedia.matches;
      const isOpen = drawer.classList.contains(openClass) && isMobile;

      toggleBtn?.setAttribute('aria-expanded', String(isOpen));
      overlay?.setAttribute('aria-hidden', String(!isOpen));
      document.body.classList.toggle(bodyOpenClass, isOpen);

      if (isMobile) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-hidden', String(!isOpen));

        if (isOpen) {
          drawer.removeAttribute('inert');
        } else {
          drawer.setAttribute('inert', '');
        }
      } else {
        drawer.classList.remove(openClass);
        overlay?.classList.remove(overlayClass);
        if (mobileFilterSectionsOpened) {
          filterSectionInitialState.forEach(({ section, open }) => {
            section.open = open;
          });
          mobileFilterSectionsOpened = false;
        }
        drawer.setAttribute('role', 'complementary');
        drawer.removeAttribute('aria-modal');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.removeAttribute('inert');
        document.body.style.overflow = '';
      }
    };

    const openMobileFilterSections = () => {
      if (!shouldOpenMobileFilterSections || mobileFilterSectionsOpened) return;

      filterSectionInitialState.forEach(({ section }) => {
        section.open = true;
      });
      mobileFilterSectionsOpened = true;
    };

    const open = () => {
      if (!mobileMedia.matches) return;

      previousBodyOverflow = document.body.style.overflow;
      drawer.classList.add(openClass);
      overlay?.classList.add(overlayClass);
      document.body.style.overflow = 'hidden';
      openMobileFilterSections();
      syncAccessibility();
      closeBtn?.focus();
    };

    const close = ({ restoreFocus = true } = {}) => {
      drawer.classList.remove(openClass);
      overlay?.classList.remove(overlayClass);
      document.body.style.overflow = previousBodyOverflow || '';
      syncAccessibility();

      if (restoreFocus) {
        toggleBtn?.focus();
      }
    };

    const trapFocus = (event) => {
      if (!mobileMedia.matches || !drawer.classList.contains(openClass) || event.key !== 'Tab') {
        return;
      }

      const focusableElements = getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    toggleBtn?.addEventListener('click', () => {
      if (drawer.classList.contains(openClass)) {
        close();
      } else {
        open();
      }
    });
    closeBtn?.addEventListener('click', close);
    overlay?.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains(openClass)) {
        close();
      }

      trapFocus(event);
    });

    const handleViewportChange = () => {
      if (!mobileMedia.matches && drawer.classList.contains(openClass)) {
        close({ restoreFocus: false });
      }

      syncAccessibility();
    };

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', handleViewportChange);
    } else {
      mobileMedia.addListener(handleViewportChange);
    }

    syncAccessibility();
  };

  const initSortSelect = () => {
    const select = $('[data-sort-select]');

    select?.addEventListener('change', () => {
      const url = new URL(location);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      navigateToResults(url);
    });
  };

  const initFilterForm = () => {
    const form = $('[data-filter-form]');
    if (!form || !$('[data-products-grid]')) return;

    const mobileMedia = window.matchMedia('(max-width: 1199px)');
    const pendingCountEl = $('[data-filter-pending-count]');
    let debounceTimer;

    const updateMobileApplyState = () => {
      if (!pendingCountEl) return;

      const checkedCount = $$('input[type="checkbox"]:checked', form).length;
      const priceCount = $$('[data-price-filter]', form).filter((range) => (
        $$('input[name]', range).some((input) => input.value.trim() !== '')
      )).length;
      const selectedCount = checkedCount + priceCount;

      pendingCountEl.hidden = selectedCount === 0;
      pendingCountEl.textContent = selectedCount > 0 ? `${selectedCount} gekozen` : '';
    };

    const normalizePriceFields = () => {
      $$('[data-price-filter]', form).forEach((range) => {
        const minInput = range.querySelector('[data-price-min]');
        const maxInput = range.querySelector('[data-price-max]');
        if (!minInput || !maxInput) return;

        const parse = (input) => {
          const value = input.value.trim().replace(',', '.');
          const number = Number.parseFloat(value);
          return Number.isFinite(number) ? Math.max(0, number) : null;
        };

        const min = parse(minInput);
        const max = parse(maxInput);

        if (min !== null) minInput.value = String(min);
        if (max !== null) maxInput.value = String(max);

        if (min !== null && max !== null && min > max) {
          minInput.value = String(max);
          maxInput.value = String(min);
        }
      });
    };

    const go = () => {
      normalizePriceFields();

      const url = new URL(location);
      const sort = url.searchParams.get('sort_by');
      const formData = new FormData(form);
      const resetParams = new Set([...url.searchParams.keys()].filter(
        (key) => key.startsWith('filter.') || key === 'page',
      ));

      for (const key of formData.keys()) {
        resetParams.add(key);
      }

      resetParams.forEach((key) => url.searchParams.delete(key));

      for (const [key, value] of formData) {
        if (value) {
          url.searchParams.append(key, value);
        }
      }

      if (sort) {
        url.searchParams.set('sort_by', sort);
      }

      navigateToResults(url);
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      clearTimeout(debounceTimer);
      go();
    });

    form.addEventListener('change', (event) => {
      clearTimeout(debounceTimer);
      updateMobileApplyState();

      if (mobileMedia.matches) {
        return;
      }

      if (event.target.closest('[data-price-filter]')) {
        return;
      }

      if (event.target.type === 'checkbox') {
        go();
      } else {
        debounceTimer = setTimeout(go, 500);
      }
    });

    form.addEventListener('input', updateMobileApplyState);

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', updateMobileApplyState);
    } else {
      mobileMedia.addListener(updateMobileApplyState);
    }

    updateMobileApplyState();

    addEventListener('popstate', () => location.reload());
  };

  const initPriceFilters = () => {
    const priceFilters = $$('[data-price-filter]');
    if (!priceFilters.length) return;

    const params = new URL(location).searchParams;

    priceFilters.forEach((range) => {
      $$('input[name]', range).forEach((input) => {
        if (!input.value && params.has(input.name)) {
          input.value = params.get(input.name);
        }
      });
    });
  };

  const initDeferredHoverImages = () => {
    const cards = [...document.querySelectorAll('.product-item-collection')].filter(
      (card) => card.querySelector('[data-hover-image]'),
    );
    if (!cards.length) return;

    const getConnection = () =>
      navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    const canPrewarmHoverImages = () => {
      const connection = getConnection();
      if (connection?.saveData) return false;
      if (/2g/.test(connection?.effectiveType || '')) return false;
      return true;
    };

    const runWhenIdle = (callback, timeout = 1500) => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(callback, { timeout });
      } else {
        setTimeout(callback, 250);
      }
    };

    const runAfterNextFrame = (callback) => {
      if ('requestAnimationFrame' in window) {
        requestAnimationFrame(() => setTimeout(callback, 0));
      } else {
        setTimeout(callback, 0);
      }
    };

    const hoverImageRequests = new WeakMap();

    const loadHoverImage = (
      card,
      fetchPriority = 'auto',
      { decodeBeforeReveal = true } = {},
    ) =>
      new Promise((resolve) => {
        const placeholder = card?.querySelector('[data-hover-image]');
        if (
          !placeholder ||
          placeholder.dataset.loaded === 'true' ||
          !placeholder.dataset.src
        ) {
          resolve(false);
          return;
        }

        const pendingRequest = hoverImageRequests.get(placeholder);
        if (pendingRequest) {
          if (fetchPriority === 'high' && 'fetchPriority' in pendingRequest.image) {
            pendingRequest.image.fetchPriority = 'high';
          }
          if (!decodeBeforeReveal) {
            pendingRequest.decodeBeforeReveal = false;
          }
          pendingRequest.promise.then(resolve);
          return;
        }

        placeholder.dataset.loading = 'true';

        const image = new Image();
        image.className = placeholder.className
          .replace(' product-item-collection__image--deferred', '')
          .replace('product-item-collection__image--deferred', '')
          .trim();
        image.alt = '';
        image.decoding = 'async';
        image.loading = 'eager';
        image.setAttribute('aria-hidden', 'true');
        if ('fetchPriority' in image) {
          image.fetchPriority = fetchPriority;
        }

        if (placeholder.dataset.width) image.width = placeholder.dataset.width;
        if (placeholder.dataset.height) image.height = placeholder.dataset.height;
        if (placeholder.dataset.sizes) image.sizes = placeholder.dataset.sizes;
        if (placeholder.dataset.srcset) image.srcset = placeholder.dataset.srcset;

        let requestResolve = () => {};
        const request = {
          image,
          decodeBeforeReveal,
          promise: new Promise((resolveRequest) => {
            requestResolve = resolveRequest;
          }),
        };
        let settled = false;
        const finish = (loaded) => {
          if (settled) return;
          settled = true;
          hoverImageRequests.delete(placeholder);
          resolve(loaded);
          requestResolve(loaded);
        };

        const reveal = () => {
          if (!placeholder.isConnected) {
            finish(false);
            return;
          }

          placeholder.dataset.loaded = 'true';
          placeholder.replaceWith(image);
          card.classList.add('product-item-collection--hover-ready');
          finish(true);
        };

        image.onload = () => {
          if (request.decodeBeforeReveal && image.decode) {
            image.decode().catch(() => {}).finally(reveal);
          } else {
            reveal();
          }
        };
        image.onerror = () => {
          placeholder.dataset.loading = 'false';
          placeholder.dataset.loaded = 'false';
          finish(false);
        };

        hoverImageRequests.set(placeholder, request);
        image.src = placeholder.dataset.src;
      });

    const queue = [];
    const queuedCards = new WeakSet();
    const maxConcurrentLoads = 2;
    let activeLoads = 0;

    const processQueue = () => {
      while (activeLoads < maxConcurrentLoads && queue.length) {
        const card = queue.shift();
        activeLoads += 1;
        loadHoverImage(card, 'low').finally(() => {
          activeLoads -= 1;
          runWhenIdle(processQueue, 1000);
        });
      }
    };

    const enqueueCard = (card) => {
      if (!card || queuedCards.has(card)) return;
      queuedCards.add(card);
      queue.push(card);
      processQueue();
    };

    const startPrewarm = () => {
      if (!canPrewarmHoverImages()) return;

      if (!('IntersectionObserver' in window)) {
        cards.slice(0, 8).forEach(enqueueCard);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            enqueueCard(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '700px 0px', threshold: 0.01 },
      );

      cards.forEach((card) => observer.observe(card));
    };

    const startInitialHoverPrewarm = () => {
      if (!canPrewarmHoverImages()) return;
      const fineHoverMedia = window.matchMedia?.('(hover: hover) and (pointer: fine)');
      if (!fineHoverMedia?.matches) return;

      const priorityCards = cards.filter(
        (card) => card.dataset.hoverPrewarm === 'true',
      );
      if (!priorityCards.length) return;

      let index = 0;
      let activePriorityLoads = 0;
      const maxPriorityLoads = Math.min(3, priorityCards.length);

      const loadNextPriorityCard = () => {
        while (activePriorityLoads < maxPriorityLoads && index < priorityCards.length) {
          const card = priorityCards[index];
          index += 1;
          activePriorityLoads += 1;

          loadHoverImage(card, 'auto', { decodeBeforeReveal: false }).finally(() => {
            activePriorityLoads -= 1;
            loadNextPriorityCard();
          });
        }
      };

      loadNextPriorityCard();
    };

    const waitForCollectionLcpImage = (
      callback,
      { waitForIdle = true, decodeBeforeRun = true } = {},
    ) => {
      const primaryImage =
        document.querySelector(
          '.products-grid .product-item-collection__image--primary[fetchpriority="high"]',
        ) || document.querySelector('.products-grid .product-item-collection__image--primary');
      let didRun = false;

      const run = () => {
        if (didRun) return;
        didRun = true;
        callback();
      };

      const afterImage = () => {
        if (waitForIdle) {
          runWhenIdle(run, 2000);
        } else {
          runAfterNextFrame(run);
        }
      };

      const decodeThenRun = () => {
        if (decodeBeforeRun && primaryImage?.decode) {
          primaryImage.decode().catch(() => {}).finally(afterImage);
        } else {
          afterImage();
        }
      };

      if (primaryImage) {
        if (primaryImage.complete) {
          decodeThenRun();
        } else {
          primaryImage.addEventListener('load', decodeThenRun, { once: true });
          primaryImage.addEventListener('error', afterImage, { once: true });
          setTimeout(afterImage, 3000);
        }
      } else if (document.readyState === 'complete') {
        afterImage();
      } else {
        addEventListener('load', afterImage, { once: true });
        setTimeout(afterImage, 3000);
      }
    };

    const warmCard = (event) => {
      const card = event.target.closest?.('.product-item-collection');
      if (card) loadHoverImage(card, 'high', { decodeBeforeReveal: false });
    };

    document.addEventListener('pointerover', warmCard, { passive: true });
    document.addEventListener('mouseover', warmCard, { passive: true });
    document.addEventListener('focusin', warmCard);
    document.addEventListener('touchstart', warmCard, { passive: true });

    waitForCollectionLcpImage(startInitialHoverPrewarm, {
      waitForIdle: false,
      decodeBeforeRun: false,
    });
    waitForCollectionLcpImage(startPrewarm);
  };

  const initShowMore = () => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-show-more-button]');
      if (!button) return;

      const filterList =
        button.closest('[data-filter-list]') ||
        button.closest('.color-swatch-filter');
      const expandable = filterList?.querySelector(
        '[data-expandable-content]',
      );

      if (!expandable) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';

      expandable.classList.toggle('is-collapsed', expanded);
      expandable.toggleAttribute('hidden', expanded);
      button.setAttribute('aria-expanded', String(!expanded));
      button.classList.toggle('filter-show-more--expanded', !expanded);

      const text = button.querySelector('[data-show-more-text]');
      if (text) {
        text.textContent = expanded ? 'Bekijk meer' : 'Toon minder';
      }
    });
  };

  const initCollectionLinks = (root = document) => {
    const containers = root.matches?.('[data-collection-links]')
      ? [root]
      : $$('[data-collection-links]', root);

    containers.forEach((container) => {
      if (container.dataset.collectionLinksInitialized === 'true') return;

      const viewport = container.querySelector('[data-collection-links-viewport]');
      const prev = container.querySelector('[data-collection-links-prev]');
      const next = container.querySelector('[data-collection-links-next]');

      if (!viewport || !prev || !next) return;

      container.dataset.collectionLinksInitialized = 'true';
      let rafId = 0;
      let scrollEndTimer = 0;
      let targetScrollLeft = viewport.scrollLeft;
      let hasPendingScrollTarget = false;

      const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const clampScroll = (left, max = maxScroll()) => Math.max(0, Math.min(left, max));

      const updateControls = (left = viewport.scrollLeft) => {
        const max = maxScroll();
        const isScrollable = max > 1;
        const clampedLeft = clampScroll(left, max);

        container.classList.toggle('collection-links--scrollable', isScrollable);
        prev.disabled = !isScrollable || clampedLeft <= 1;
        next.disabled = !isScrollable || clampedLeft >= max - 1;

        if (!isScrollable) {
          hasPendingScrollTarget = false;
          targetScrollLeft = 0;
        } else {
          targetScrollLeft = clampScroll(targetScrollLeft, max);
        }
      };

      const finishScroll = () => {
        hasPendingScrollTarget = false;
        targetScrollLeft = clampScroll(viewport.scrollLeft);
        updateControls(targetScrollLeft);
      };

      const update = () => {
        if (!hasPendingScrollTarget) {
          targetScrollLeft = clampScroll(viewport.scrollLeft);
        }

        updateControls(hasPendingScrollTarget ? targetScrollLeft : viewport.scrollLeft);
      };

      const scheduleUpdate = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(update);
      };

      const scheduleScrollEnd = () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(finishScroll, 120);
      };

      const prefersReducedMotion = () =>
        window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

      const scroll = (direction) => {
        const max = maxScroll();
        if (max <= 1) {
          updateControls(0);
          return;
        }

        const amount = Math.max(120, Math.round(viewport.clientWidth * .8));
        const currentLeft = clampScroll(viewport.scrollLeft, max);
        const baseLeft = hasPendingScrollTarget ? targetScrollLeft : currentLeft;
        const nextLeft = clampScroll(baseLeft + direction * amount, max);

        targetScrollLeft = nextLeft;
        hasPendingScrollTarget = true;
        updateControls(nextLeft);

        if (Math.abs(currentLeft - nextLeft) <= 1) {
          finishScroll();
          return;
        }

        if (viewport.scrollTo) {
          viewport.scrollTo({
            left: nextLeft,
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          });
        } else {
          viewport.scrollLeft = nextLeft;
          finishScroll();
        }
      };

      prev.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      viewport.addEventListener('scroll', () => {
        scheduleUpdate();
        scheduleScrollEnd();
      }, { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scroll(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          scroll(1);
        }
      });
      window.addEventListener('resize', scheduleUpdate, { passive: true });

      if (document.fonts?.ready) {
        document.fonts.ready.then(scheduleUpdate).catch(() => {});
      }
      scheduleUpdate();
    });
  };

  const init = () => {
    initFilterDrawer();
    initSortSelect();
    initPriceFilters();
    initFilterForm();
    initShowMore();
    initCollectionLinks();
    initDeferredHoverImages();
  };

  const initWhenFullSearchIsReady = () => {
    Promise.resolve(window.DutchXXLTheme?.fullSearchReady)
      .catch(() => {})
      .then(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenFullSearchIsReady);
  } else {
    initWhenFullSearchIsReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionLinks(event.target);
  });
})();
